"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrations = void 0;
exports.integrations = [
    {
        type: 'keen',
        meta: {
            projectId: process.env.KEEN_PROJECT_ID,
            readKey: process.env.KEEN_READ_KEY,
            writeKey: process.env.KEEN_WRITE_KEY
        }
    },
    {
        type: 'trello',
        meta: {
            app: process.env.TRELLO_APP,
            token: process.env.TRELLO_TOKEN,
            list: process.env.TRELLO_LIST_ID
        }
    },
    {
        type: 's3',
        meta: {
            s3Bucket: process.env.S3_BUCKET_NAME
        }
    },
    {
        type: 'twilio',
        meta: {}
    },
    {
        type: 'twilioNotify',
        meta: {
            notify: /^true$/i.test(process.env.ENABLE_TWILIO_NOTIFY)
        }
    },
    {
        type: 'goGov',
        meta: {
            site: process.env.GO_GOV_SITE
        }
    },
    {
        type: 'myCivic',
        meta: {
            clientId: process.env.MY_CIVIC_CLIENT_ID,
            cityId: process.env.MY_CIVIC_CITY_ID,
            secretKey: process.env.MY_CIVIC_SECRET_KEY
        }
    },
    {
        type: 'motorola',
        meta: {
            key: process.env.MOTOROLA_KEY
        }
    },
    {
        type: 'quickbase',
        meta: {
            url: process.env.QUICKBASE_URL,
            realm_hostname: process.env.QUICKBASE_REALM_HOSTNAME,
            application_token: process.env.QUICKBASE_APPLICATION_TOKEN,
            user_token: process.env.QUICKBASE_USER_TOKEN,
            address_table_id: process.env.QUICKBASE_ADDRESS_TABLE_ID,
            service_request_table_id: process.env.QUICKBASE_SERVICE_REQUEST_TABLE_ID
        }
    },
    {
        type: 'granicus',
        meta: {
            process_id: process.env.GRANICUS_PROCESS_ID,
            url: process.env.GRANICUS_URL,
            apiKey: process.env.GRANICUS_API_KEY
        }
    },
    {
        type: 'rock-solid',
        meta: {
            app_key: process.env.ROCK_SOLID_APP_KEY,
            platform_app_key: process.env.ROCK_SOLID_PLATFORM_APP_KEY,
            base_url: process.env.ROCK_SOLID_BASE_URL,
            author_id: process.env.ROCK_SOLID_AUTHOR_ID
        }
    },
    {
        type: 'seeClickFix',
        meta: {
            url: process.env.SEE_CLICK_FIX_URL
        }
    },
    {
        type: 'cityworks_config',
        meta: {
            LoginName: process.env.CITYWORKS_CONFIG_LOGIN_NAME,
            Password: process.env.CITYWORKS_CONFIG_PASSWORD,
            URL: process.env.CITYWORKS_CONFIG_URL
        }
    },
    {
        type: 'govqa',
        meta: {
            login: process.env.GOVQA_LOGIN,
            password: process.env.GOVQA_PASSWORD,
            authKey: process.env.AUTH_KEY,
            activationKey: process.env.ACTIVATION_KEY,
            url: process.env.GOVQA_URL,
            tags: {
                service_request_type_id: 48,
                issue: 'requestData_cf_33',
                name: 'requestData_cf_34',
                phone: 'requestData_cf_35',
                dialogHistory: 'requestData_cf_29',
                citizenEmail: 'requestData_cf_36'
            }
        }
    }
];
